module.exports = __webpack_public_path__ + "static/media/thumbnail.eeb2c56c.jpg";